<template>
  <v-dialog v-model="visible" persistent max-width="1500" min-height="200" scrollable>
    <v-card>
      <v-card-title class="grey lighten-2 py-2">
        <h3 class="text-h5">Order Services</h3>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="showExisting"
          >Show Existing Services</v-btn
        >
      </v-card-title>

      <v-card-text>
        <ExistingServices
          :rowData="services"
          :existing="existingServicesDialog"
          :tableLoading="tableLoading"
          @close="existingServicesDialog = false"
        />
        <IPVoice
          :rowData="ipvoice"
          :ratePlans="ratePlans"
          :handsets="handsets"
          v-if="ipvoice && ipvoice.length > 0"
        />
        <Mobile
          :rowData="mobile"
          :ratePlans="ratePlans"
          v-if="mobile && mobile.length > 0"
          class="mt-4"
        />
        <Nbn
          :rowData="nbn"
          :ratePlans="ratePlans"
          v-if="nbn && nbn.length > 0"
          class="mt-4"
        />
        <loader-dialog
          :showLoader="showLoader && visible"
          :stockDialog="showLoader && visible"
        ></loader-dialog>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="submitServices">Sell-In Services to UB</v-btn>
        <v-btn color="default" @click="$emit(`close`)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IPVoice from "@/components/mia/order-services/ip-voice";
import Mobile from "@/components/mia/order-services/mobile";
import Nbn from "@/components/mia/order-services/nbn";
import ExistingServices from "@/components/mia/order-services/existing-services";
import LoaderDialog from "@/components/common/LoaderDialog";

export default {
  name: "order-services",
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    tableLoading: {
      type: Boolean,
      default: () => true,
    },
    order: {
      type: Object,
      default: () => {},
    },
    ubDealerID: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    existingServicesDialog: false,
    showLoader: true,
    ipvoice: [],
    mobile: [],
    nbn: [],
    services: [],
    ratePlans: [],
    handsets: [],
  }),
  watch: {
    order() {
      this.ipvoice = this.order ? this.order.iPExtensions : [];
      this.mobile = this.order ? this.order.mobiles : [];
      this.nbn = this.order ? this.order.internets : [];
      this.services = [];
    },
  },
  components: {
    IPVoice,
    Mobile,
    Nbn,
    ExistingServices,
    LoaderDialog,
  },
  beforeMount() {
    let vm = this;
    function removeLoader() {
      vm.showLoader = false;
    }
    vm.showLoader = true;
    vm.$store
      .dispatch("orders/ratePlan/getRatePlans")
      .then((res) => {
        vm.ratePlans = res.data;
        removeLoader();
      })
      .catch(() => removeLoader());

    vm.$store
      .dispatch("orders/handset/getHandsets")
      .then((res) => {
        vm.handsets = res;
        removeLoader();
      })
      .catch(() => removeLoader());
  },
  methods: {
    submitServices() {
      let vm = this;
      vm.showLoader = true;
      vm.$store
        .dispatch("orders/sellInOrderService", vm.order.orderID)
        .then(() => {
          vm.showLoader = false;
          vm.$emit("close");
        })
        .catch((err) => {
          vm.showLoader = false;
          vm.$emit("close");
        });
    },
    showExisting() {
      let vm = this;
      vm.existingServicesDialog = true;
      vm.visible = false;
      vm.tableLoading = true;
      vm.$store
        .dispatch("orders/ipVoice/getServices", vm.order.customer.ubAccountNo)
        .then((res) => {
          if (res.length > 0) 
          vm.services = res 
          vm.tableLoading = false
        })
        .catch(() =>
          vm.tableLoading = false
        )
    },
  },
};
</script>
